import React, { useState } from "react";
import {
    ArrayInput,
    Datagrid,
    DateField,
    EditButton,
    FunctionField,
    List,
    ReferenceField,
    ReferenceInput,
    ReferenceManyField,
    useRecordContext,
    Show,
    Edit,
    SimpleFormIterator,
    SimpleShowLayout,
    TextField,
    TextInput,
    SelectInput,
    SimpleForm,
    useGetList,
    Loading,
    useGetOne,
    RadioButtonGroupInput,
    SaveButton,
    Toolbar
} from 'react-admin';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { LongForm } from '@react-admin/ra-form-layout';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Grid from '@mui/material/Grid';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Importa l'icona di successo

import axios from 'axios';

import Button from '@mui/material/Button';
// import Avatar from '@mui/material/Avatar';
// import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

import LinearProgress from '@mui/material/LinearProgress';
import Typography from "@material-ui/core/Typography";
import Box from '@mui/material/Box';

// Importo il css per i Bottoni
import { showButtonCss } from '../shared/Styles/buttonStyles';
import { listCss } from '../shared/Styles/listStyles';
import { ReferenceManyToManyField } from "@react-admin/ra-relationships";

import config from '../../config/config.json';
import { Divider } from "@mui/material";
import { useRedirect } from 'react-admin';

const host = config.production.host;

export const QuizList = props => {

    return (
        <List
            pagination={null}
            title={<>
                <Button>
                    &nbsp;Pagina principale
                </Button>
            </>}
            exporter={false}
            // aside={<MacroareaFilterSidebar />}
            {...props}
            actions={null}
            perPage={50}
        // filters={aziendaFilters}
        >
            <Datagrid sx={listCss} bulkActionButtons={false} item xs={12}>
                {/*<WrapperField label="Logo Macro Area">
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, color: 'primary.main' }}>
                        <CustomAvatarImage source="urlLogo" label="Logo" ></CustomAvatarImage>
                    </Box>
                </WrapperField> */}
                {<FunctionField source="descrizione" render={record => record && <strong>{record.descrizione}</strong>} />}
                {<FunctionField source="stato" render={record => record && <strong>{record.stato}</strong>} />}
                {<DateField source="dataScadenza" label="Data scadenza" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit' }} />}
                {<DateField source="updatedAt" label="Ultima modifica" showTime options={{ year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }} />}
                {/* {<RichTextField label="Ordinamento" source="Ordinamento" />} */}
                {/* {<EditButton sx={editButtonCss} label="Modifica" />} */}
                {<FunctionField source="stato" label="Azioni" render={record => record && (record.stato == 'COMPLETATO' || record.stato == 'SCADUTO') ? null : <EditButton sx={showButtonCss} label="Vai al Quiz" />} />}
            </Datagrid>
        </List>
    );
}

const UserEditToolbar = ({ updatePercentualeAvanzamento, percentualeAvanzamento }) => {
    const [openDialog, setOpenDialog] = React.useState(false); // Stato per mostrare/nascondere il dialog
    const [showNotification, setShowNotification] = useState(false);
    const redirect = useRedirect();

    const record = useRecordContext();
    // Utilizza i dati ottenuti da useGetList per ottenere la percentuale di avanzamento
    const { data: avanzamentoData, isLoading, error } = useGetList('view-quiz-avanzamento', {
        filter: { tblQuizId: record?.id }
    });

    React.useEffect(() => {
        if (avanzamentoData && avanzamentoData.length > 0) {
            updatePercentualeAvanzamento(avanzamentoData[0].percent_avanzamento);
        }
    }, [avanzamentoData]);

    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }

    const completaQuiz = () => {
        setOpenDialog(true); // Apri il dialog quando il pulsante viene cliccato
    };

    const handleConferma = () => {
        const closeQuiz = chiudQuiz(record.id);
        if (closeQuiz) {
            // Dopo che la risposta è stata aggiornata con successo, mostra la notifica
            setShowNotification(true);
            setTimeout(() => {
                setOpenDialog(false);
                redirect('/tbl-quiz');
            }, 1000);
        }
    };

    const handleAnnulla = () => {
        setOpenDialog(false); // Chiudi il dialog quando viene annullato
    };

    // Converti le stringhe delle date in oggetti Date
    var dataScadenza = null;
    var giorniResidui = null;
    if (record?.dataScadenza) {
        const today = new Date(); // Data odierna
        dataScadenza = new Date(record.dataScadenza); // Data di scadenza dal record
        // Calcola la differenza tra le date in millisecondi
        const differenceMs = dataScadenza - today;
        // Converti la differenza da millisecondi a giorni
        giorniResidui = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));
    }


    return (
        <>
            <Toolbar sx={{ position: 'fixed', bottom: 0, left: 0, width: '100%', zIndex: 9999 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', marginLeft: '255px' }}>
                        <Typography variant="subtitle1" component="div">
                            <strong>Percentuale Avanzamento </strong>
                        </Typography>
                        <LinearProgressWithLabel value={percentualeAvanzamento} />
                    </Box>
                </Box>
                {dataScadenza && <Typography variant="subtitle1" component="div">
                    <strong>Scade tra {giorniResidui} giorni</strong>
                </Typography>}
                {percentualeAvanzamento == 100 && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={completaQuiz}
                        sx={{ borderRadius: '10px', marginLeft: '10px' }}
                    >
                        Completa Quiz
                    </Button>
                )}
            </Toolbar>
            <Dialog open={openDialog} onClose={handleAnnulla}>
                <Toolbar sx={{ backgroundColor: 'primary.main', color: 'white' }}>
                    <DialogTitle sx={{ textTransform: 'uppercase' }}>Completa Quiz</DialogTitle>
                </Toolbar>
                <DialogContent>
                    <Typography variant="subtitle1">Sei sicuro di voler completare il quiz?</Typography>
                    <Typography variant="body1">Cliccando su Conferma il Quiz sarà consegnato e sarai valutato dall'amministrazione.</Typography>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between' }}>
                    <Button variant="contained" onClick={handleAnnulla} color="primary" sx={{ borderRadius: '10px' }}>
                        Annulla
                    </Button>
                    <Button variant="contained" onClick={handleConferma} color="primary" sx={{ borderRadius: '10px' }}>
                        Conferma
                    </Button>
                </DialogActions>
                <Snackbar
                    open={showNotification}
                    autoHideDuration={2000}
                    color="primary"
                    onClose={() => setShowNotification(false)}
                    style={{ position: 'absolute', bottom: '20px', left: '50%', transform: 'translateX(-50%)' }}>
                    <Alert onClose={() => setShowNotification(false)} severity="success" color="primary" sx={{ width: '100%' }}>
                        Quiz completato con successo
                    </Alert>
                </Snackbar>
            </Dialog>
        </>
    );
};

const chiudQuiz = async (quizId, setOpenDialog) => {
    try {

        const jwt = localStorage.getItem("feathers-jwt");
        let data = JSON.stringify({
            "stato": 'COMPLETATO'
        });


        let config = {
            method: 'patch',
            maxBodyLength: Infinity,
            url: host + '/tbl-quiz/' + quizId,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + jwt
            },
            data: data
        };


        axios.request(config)
            .then((response) => {
                // Dopo che la risposta è stata aggiornata con successo, mostra la notifica
                setOpenDialog(false);
                //redirect to i miei quiz
                return true;
            })
            .catch((error) => {
                console.log(error);
                return false;
            });
    } catch (error) {
        console.error('Error updating answer:', error.message);
    }
};


function LinearProgressWithLabel(percentualeAvanzamento) {
    const progressValue = parseFloat(percentualeAvanzamento.value);
    return (
        <>
            <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                <Box sx={{ width: '200px', ml: 1, mr: 1 }}>
                    <LinearProgress variant="determinate" value={progressValue} />
                </Box>
                <Typography variant="subtitle1" sx={{ minWidth: 35 }}>
                    {<strong>{Math.round(progressValue)}%</strong>}
                </Typography>
            </Box>
        </>
    );
}


export const QuizEdit = ({ record, ...props }) => {
    const [percentualeAvanzamento, setPercentualeAvanzamento] = React.useState(0);
    const updatePercentualeAvanzamento = (newPercentuale) => {
        setPercentualeAvanzamento(newPercentuale);
    };

    return (
        <Show component="div"  {...props} title={<>
            {<FunctionField source="descrizione" render={record => record && <h3>{record.descrizione}</h3>} />}
        </>} actions={null}>

            <LongForm toolbar={<UserEditToolbar updatePercentualeAvanzamento={updatePercentualeAvanzamento} percentualeAvanzamento={percentualeAvanzamento} />}>
                <LongForm.Section label="Step 1">
                    {/* <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                        </AccordionSummary>
                        <AccordionDetails> */}
                    <QuizLongFormSection pagina={1} updatePercentualeAvanzamento={updatePercentualeAvanzamento}></QuizLongFormSection>
                    {/* </AccordionDetails> */}
                    {/* </Accordion> */}
                </LongForm.Section>
                <LongForm.Section label="Step 2">
                    <QuizLongFormSection pagina={2} updatePercentualeAvanzamento={updatePercentualeAvanzamento}></QuizLongFormSection>
                </LongForm.Section>
                <LongForm.Section label="Step 3">
                    <QuizLongFormSection pagina={3} updatePercentualeAvanzamento={updatePercentualeAvanzamento}></QuizLongFormSection>
                </LongForm.Section>
                <LongForm.Section label="Step 4">
                    <QuizLongFormSection pagina={4} updatePercentualeAvanzamento={updatePercentualeAvanzamento}></QuizLongFormSection>
                </LongForm.Section>
                <LongForm.Section label="Step 5">
                    <QuizLongFormSection pagina={5} updatePercentualeAvanzamento={updatePercentualeAvanzamento}></QuizLongFormSection>
                </LongForm.Section>
                <LongForm.Section label="Step 6">
                    <QuizLongFormSection pagina={6} updatePercentualeAvanzamento={updatePercentualeAvanzamento}></QuizLongFormSection>
                </LongForm.Section>
            </LongForm>
        </Show>
    );
}

const QuizLongFormSection = ({ pagina, updatePercentualeAvanzamento }) => {
    const record = useRecordContext();
    const { data, isLoading, error } = useGetList(
        'tbl-quiz-domande',
        {
            pagination: { page: pagina, perPage: 50 },
            sort: { field: 'id', order: 'DESC' },
            filter: { tblQuizId: record ? record.id : null }
        }
    );

    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }
    return (
        <>
            {data.map(record =>
                <GetQuestion key={record.id} quizDomandaId={record.id} domandaId={record.tblDomandeId} rispostaUser={record.rispostaUser} updatePercentualeAvanzamento={updatePercentualeAvanzamento}>{record}</GetQuestion>
            )}
        </>
    );
};

const GetQuestion = ({ quizDomandaId, domandaId, rispostaUser, updatePercentualeAvanzamento }) => {
    const [showNotification, setShowNotification] = useState(false);
    const [textColor, setTextColor] = useState(rispostaUser ? 'green' : 'red');
    const { data, isLoading, error } = useGetOne('tbl-domande', { id: domandaId });
    if (isLoading) { return <Loading />; }
    if (error) { return <p>ERROR</p>; }
    const answers = [
        { id: data.risposta1, name: data.risposta1 },
        { id: data.risposta2, name: data.risposta2 },
        { id: data.risposta3, name: data.risposta3 }
    ];
    const source = `risposta_${domandaId}`; // Genera un source univoco basato sull'ID della domanda
    const defaultAnswer = rispostaUser ? rispostaUser : undefined;

    const updateAnswer = async (rispostaUser) => {
        try {
            const jwt = localStorage.getItem("feathers-jwt");
            let data = JSON.stringify({
                "rispostaUser": rispostaUser
            });

            let config = {
                method: 'patch',
                maxBodyLength: Infinity,
                url: host + '/tbl-quiz-domande/' + quizDomandaId,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + jwt
                },
                data: data
            };

            axios.request(config)
                .then((response) => {
                    updatePercentualeAvanzamento(response.data.percent_avanzamento);
                    // Dopo che la risposta è stata aggiornata con successo, mostra la notifica
                    setShowNotification(true);
                    // Aggiorna il colore del testo
                    setTextColor('inherit');
                })
                .catch((error) => {
                    console.log(error);
                });
        } catch (error) {
            console.error('Error updating answer:', error.message);
        }
    };

    if (error) { return <p>ERROR</p>; }

    return (
        <>
            <div style={{ position: 'relative' }}>
                <RadioButtonGroupInput
                    key={domandaId}
                    label={<h4 style={{ fontWeight: 'bold', fontSize: '22px', color: textColor }}>{data.descrizione/*  + ' -> ' + data.id */}</h4>}
                    source={source}
                    choices={answers.map(choice => ({
                        ...choice,
                        textColor: textColor
                    }))}
                    defaultValue={defaultAnswer}
                    onChange={(e) => updateAnswer(e.target.value)}
                    isRequired
                />
                <Snackbar
                    open={showNotification}
                    autoHideDuration={1500}
                    color="primary"
                    onClose={() => setShowNotification(false)}
                    style={{ position: 'absolute', bottom: '20px', left: '30%', transform: 'translateX(-50%)' }}>
                    <Alert onClose={() => setShowNotification(false)} severity="success" color="primary" sx={{ width: '100%' }}>
                        Risposta aggiornata
                    </Alert>
                </Snackbar>
            </div>
            <Divider></Divider>
        </>
    );
}
